import './style.scss';
import { Loader } from "react-feather";
import { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
// import * as yup from 'yup';
import { FormSchema } from './schema';

const ContactForm = () => {
  const [loader, setLoader] = useState(false);

  const handleSubmit = async (values, { resetForm }) => {
    if (loader) return;

    try {
      setLoader(true);
      const response = await fetch("https://contact-us-2-z9hbu.ondigitalocean.app/api/v1/contact-us", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        alert("Message sent successfully!");
        resetForm();
      } else {
        alert("Failed to send the message. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert("An error occurred. Please try again later.");
    } finally {
      setLoader(false);
    }
  }

  return (
    <section className='contact' id='contact'>
      <h2 style={{ color: '#ffffff' }} className="main-title">Contact Us</h2>
      <div className='container-lg'>
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
          }}
          validationSchema={FormSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form className='contact-form'>
              <div className='grid grid-cols-2 gap-15'>
                <div className='gorm-group'>
                  <Field
                    type='text'
                    name='firstName'
                    placeholder='First Name'
                    className={`input ${errors.firstName && touched.firstName ? 'error-border' : ''}`}
                    id='first-name'
                    disabled={isSubmitting || loader}
                  />
                  <ErrorMessage name="firstName" component="div" className="error" />
                </div>
                <div className='gorm-group'>
                  <Field
                    type='text'
                    name='lastName'
                    placeholder='Last Name'
                    className={`input ${errors.lastName && touched.lastName ? 'error-border' : ''}`}
                    id='last-name'
                    disabled={isSubmitting || loader}
                  />
                  <ErrorMessage name="lastName" component="div" className="error" />
                </div>
              </div>
              <div className='gorm-group'>
                <Field
                  type='email'
                  name='email'
                  placeholder='Email'
                  className={`input ${errors.email && touched.email ? 'error-border' : ''}`}
                  id='email'
                  disabled={isSubmitting || loader}
                />
                <ErrorMessage name="email" component="div" className="error" />
              </div>
              <div className='gorm-group'>
                <Field
                  type='number'
                  name='phoneNumber'
                  placeholder='Phone Number'
                  className={`input ${errors.phoneNumber && touched.phoneNumber ? 'error-border' : ''}`}
                  id='phoneNumber'
                  disabled={isSubmitting || loader}
                />
                <ErrorMessage name="phoneNumber" component="div" className="error" />
              </div>
              <div className='gorm-group'>
                <Field
                  name='message'
                  as='textarea'
                  id='message'
                  placeholder='Message'
                  className='user-msg'
                  disabled={isSubmitting || loader}
                />
                {/* <ErrorMessage name="message" component="div" className="error" /> */}
              </div>
              <div className='btn-wrapper'>
                <button type="submit" disabled={isSubmitting || loader} className='btn'>
                  {loader ? (
                    <Loader className="icon loader-icon" />
                  ) : (
                    <>SUBMIT</>
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
}

export default ContactForm;
